export const TEXT_KEYS = {
    FOOTER_TERMS_AND_CONDITIONS: 'footer__terms-and-conditions'
};
